import {Repository} from "./Repository";
import {AxiosInstance} from "axios";

export class MessengerRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    getMessagesByRoomId(roomId: string, params: any) {
        return this.client.get(`/v2/messenger/message/list/${roomId}`, {
            params: params
        })
        .then(({ data }) => {
            const items = data || [];
            return items
        });
    }
}